import { useState, useCallback } from "react";

const useUndoRedo = (initialValue = "") => {
  const [history, setHistory] = useState([initialValue]); 
  const [index, setIndex] = useState(0); 
  
  const updateValue = useCallback((newValue) => {
    const updatedHistory = history.slice(0, index + 1);
    setHistory([...updatedHistory, newValue]);
    setIndex(updatedHistory.length);
  }, [history, index]);

  const undo = useCallback(() => {
    if (index > 0) {
      setIndex(index - 1);
    }
  }, [index]);

  const redo = useCallback(() => {
    if (index < history.length - 1) {
      setIndex(index + 1);
    }
  }, [index, history]);

  return {
    value: history[index],
    updateValue,
    undo,
    redo,
  };
};

export default useUndoRedo;
